import React from 'react';
import styled from 'styled-components';
import { getDateTime } from '../../services/date.service';
import { DATE_READABLE_MONTH_YEAR_FORMAT } from '../../constants/date.contant';
import IconButtonComponent from '../IconButton.component';
import ChevronLeftIcon from '../Icons/ChevronLeft.icon';
import ChevronRightIcon from '../Icons/ChevronRight.icon';
import dayjs from 'dayjs';

export interface EventsHeaderProps extends React.AllHTMLAttributes<HTMLElement> {
  date: number;
  onChangeMonth: Function;
}

const StyledMonthYearLabel = styled.div`
  text-transform: capitalize;
  font-size: large;
`;
const StyledCalendarHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-left: 22px;
`;
const StyledCalendarHeader = styled.div``;

const CHEVRON_ICON_SIZE = 18;

const EventsHeaderComponent = ({ date, onChangeMonth }: EventsHeaderProps) => {
  const monthYearString = getDateTime(date, DATE_READABLE_MONTH_YEAR_FORMAT);
  
  const handlePrevMonth = () => onChangeMonth(
    dayjs(date)
      .subtract(1, 'months')
      .startOf('month')
      .unix() * 1000
  );
  
  const handleNextMonth = () => onChangeMonth(
    dayjs(date)
      .add(1, 'months')
      .startOf('month')
      .unix() * 1000
  );
  
  return (
    <StyledCalendarHeader>
      <StyledCalendarHeaderContent>
        <IconButtonComponent onClick={handlePrevMonth}>
          <ChevronLeftIcon width={CHEVRON_ICON_SIZE} height={CHEVRON_ICON_SIZE} />
        </IconButtonComponent>
        <IconButtonComponent onClick={handleNextMonth}>
          <ChevronRightIcon width={CHEVRON_ICON_SIZE} height={CHEVRON_ICON_SIZE} />
        </IconButtonComponent>
        <StyledMonthYearLabel>
          {monthYearString}
        </StyledMonthYearLabel>
      </StyledCalendarHeaderContent>
    </StyledCalendarHeader>
  );
};

export default EventsHeaderComponent;
